<template>
  <div class="home-container">
    <div class="header">
      <div class="header-content">
        <div class="header-left">
          <h1 class="title">🎁 机器人知识挑战赛</h1>
          <p class="subtitle">挑战你的AI知识，赢取精美奖品！</p>
        </div>
      </div>
      <button class="record-btn" @click="viewRecords">
          我的抽奖记录
        </button>
    </div>
    
    <!-- URL参数显示区域 -->
      <!-- <div class="params-display" v-if="Object.keys(getGlobalParams()).length > 0">
        <h3>URL参数信息：</h3>
        <ul>
          <li v-for="(value, key) in getGlobalParams()" :key="key">
            {{ key }}: {{ value }}
          </li>
        </ul>
      </div> -->
    
    <div class="content">
      <div class="card">
        <div class="card-icon"><img src="../images/jqf.png" alt="机器人图标"></div>
        <h2 class="card-title">参与挑战</h2>
        <p class="card-description">
          回答5道机器人相关的知识问题，测试你的AI知识储备。
          答对4道以上即可获得抽奖机会，赢取丰厚奖品！
        </p>
        <button class="start-btn" @click="startQuiz">
          <span>开始答题</span>
          <i class="arrow-right"></i>
        </button>
      </div>
      
      <div class="features">
        <div class="feature-item">
          <div class="feature-icon">📚</div>
          <h3 class="feature-title">趣味答题</h3>
          <p class="feature-desc">5道精选机器人知识题</p>
        </div>
        <div class="feature-item">
          <div class="feature-icon">🎯</div>
          <h3 class="feature-title">高概率中奖</h3>
          <p class="feature-desc">答对即可参与抽奖</p>
        </div>
        <div class="feature-item">
          <div class="feature-icon">🏆</div>
          <h3 class="feature-title">丰厚奖品</h3>
          <p class="feature-desc">多种精美礼品等你来拿</p>
        </div>
      </div>
    </div>
    
    <div class="footer">
      <p>© 2025 机器人知识挑战赛 | 活动最终解释权归主办方所有</p>
    </div>

      <!-- 
      公众号二维码弹窗
      使用条件渲染(v-if)控制显示/隐藏
      点击弹窗外区域(@click.self)可以关闭弹窗
    -->
    <div class="qrcode-modal" v-if="showQrcode" @click.self="showQrcode = false">
      <div class="modal-content">
        <!-- 弹窗关闭按钮，点击后隐藏弹窗 -->
        <div class="close-btn" @click="showQrcode = false">×</div>
        
        <!-- 弹窗标题，指导用户如何操作 -->
        <h3>长按识别二维码</h3>
        
        <!-- 二维码显示区域 -->
        <div class="qrcode-container">
          <!-- 
            二维码占位符
            使用SVG格式实现，确保在各种设备上清晰显示
            实际项目中应替换为真实的公众号二维码
          -->
          <div class="qrcode-placeholder">
            <!-- 公众号二维码图片 -->
            <img src="../images/jqr.jpg" alt="公众号二维码" style="width: 200px; height: 200px;"/>
          </div> 
          <!-- 扫描提示文本 -->
          <p class="qrcode-tip">关注公众号每天可以参与抽大奖</p>
        </div>
        <!-- 用户操作指引 -->
        <!-- <p class="follow-instruction">关注成功后，点击下方按钮确认</p> -->
        
        <!-- 
          确认按钮
          点击后调用confirmFollow方法，处理用户确认关注的逻辑
          显示加载状态时禁用按钮并显示加载文本
        -->
        <!-- <button class="confirm-btn" @click="confirmFollow" :disabled="showLoading">
          <span v-if="showLoading">验证中...</span>
          <span v-else>已关注，领取机会</span>
        </button> -->
      </div>
    </div>
         <!---活动状态验证弹框--->
    <div class="act-modal" v-if="!showActStatus" @click.self="showActStatus = true">
      <div class="act-content">
        <!-- 弹窗关闭按钮，点击后隐藏弹窗 -->
        <div class="close-btn" @click="showActStatus = true">×</div>
        
        <!-- 状态图标 -->
        <div class="status-icon">
          <span v-if="act_Status_Msg.includes('未开始')">⏰</span>
          <span v-else-if="act_Status_Msg.includes('已结束')">🎊</span>
          <span v-else-if="act_Status_Msg.includes('参与')">📝</span>
          <span v-else>ℹ️</span>
        </div>
        
        <!-- 状态标题 -->
        <h3 class="status-title">{{act_Status_Msg}}</h3>
        
        <!-- 状态消息 -->
        <p class="act-tip">{{act_Status_Msg.includes('未开始') ? '敬请期待' : act_Status_Msg.includes('已结束') ? '期待下次参加' : '活动状态通知'}}</p>
        
        <!-- 确认按钮 -->
        <button class="status-confirm-btn" @click="showActStatus = true">我知道了</button>
      </div>
    </div>  
  </div>
</template>

<script>
import globalStore from '../utils/globalStore.js';
import { prizeAPI,lotteryAPI } from '../utils/api';
export default {
  name: 'Home',
  data() {
    return {
      showQrcode: false, // 控制二维码弹窗的显示状态
      showLoading: false, // 控制加载状态的显示
      act_Status_Msg: '活动暂未开始', // 活动状态提示消息
      showActStatus: true, // 控制活动状态弹窗的显示状态
    }
  },
  created() {
    // 在组件创建时获取URL参数并存储到全局状态
    const urlParams = { ...this.$route.query }
    // 直接使用globalStore设置参数是允许的，因为这是在组件方法内部
    globalStore.setUrlParams(urlParams)
    //console.log('URL参数信息:', urlParams)
  },
  methods: {
     /**
     * 确认关注公众号方法
     * 模拟用户关注公众号后，重定向到抽奖页面
     * 在实际项目中，应该调用API验证用户是否真的关注了公众号
     */
    // 确认关注公众号方法
    async confirmFollow() {
      try {
        // 显示加载状态
        this.showLoading = true;
        
        // 调用API验证用户关注状态
        // 这里使用实际的API调用，而不是模拟
        const response = await prizeAPI.verifyFollowStatus(globalStore.getUrlParams());
        //console.log("验证关注状态响应:",response);
        // 根据验证结果处理
        if (response && response.code==0 && response.data.isFollowed) {
          // 用户已关注，关闭弹窗并跳转到答题页面
          this.showQrcode = false;
          // 记录用户行为（实际应用中应调用后端API）
          //console.log('用户已关注公众号，允许参与活动');
          await this.fetchLotteryStatus();
          
        } else {
          // 用户未关注，显示提示
         //('请先关注公众号后再继续');
          // 保持弹窗开启，让用户继续关注
        }
      } catch (error) {
        console.error('验证关注状态失败:', error);
        alert('网络错误，请稍后重试');
      } finally {
        // 无论成功失败，都隐藏加载状态
        this.showLoading = false;
      }
    },
    // 获取抽奖活动状态
    async fetchLotteryStatus() {
      try {
        // 尝试调用API，失败时使用模拟数据
        const response = await lotteryAPI.getLotteryStatus(globalStore.getUrlParams());
        if (response.code==0) {
          if(response.data.act_Status!=null){
            this.showActStatus = response.data.act_Status;
            this.act_Status_Msg = response.data.act_Status_Msg;
            //console.log('活动状态:',this.showActStatus)
            if(this.showActStatus){
              // 跳转到答题页面，传递全局URL参数
              this.$router.push({
                path: '/quiz',
                query: globalStore.getUrlParams()
              });
            }
          }
        }
      } catch (error) {
        //console.log('使用模拟数据');
      } 
    },
    // 开始答题方法
    async startQuiz() {
      // 显示二维码弹窗，让用户关注公众号
      // 实际应用中，这里应该先调用API检查用户是否已经关注了公众号
      // 如果未关注，才显示二维码
     // this.showQrcode = true
     try {
        // 显示加载状态
        this.showLoading = true;
        // 调用API验证用户关注状态
        // 这里使用实际的API调用，而不是模拟
        const response = await prizeAPI.verifyFollowStatus(globalStore.getUrlParams());
        //console.log("验证关注状态响应:",response);
        // 根据验证结果处理
        if (response && response.code==0 && response.data.isFollowed) {
          // 用户已关注，关闭弹窗并跳转到答题页面
          this.showQrcode = false;
          // 跳转到答题页面，传递全局URL参数
           await this.fetchLotteryStatus();
          
          // this.$router.push({
          //   path: '/quiz',
          //   query: globalStore.getUrlParams()
          // });
        } else {
          // 用户未关注，显示提示
        //  alert('请先关注公众号后再继续');
          // 保持弹窗开启，让用户继续关注
           this.showQrcode = true
        }
      } catch (error) {
        console.error('验证关注状态失败:', error);
        alert('网络错误，请稍后重试');
      } finally {
        // 无论成功失败，都隐藏加载状态
        this.showLoading = false;
      }
    },
    
    // 获取全局参数的方法
    getGlobalParams() {
      return globalStore.getUrlParams();
    },
    
    // 查看抽奖记录方法
    async viewRecords() {
      // 显示二维码弹窗，让用户关注公众号
      // 实际应用中，这里应该先调用API检查用户是否已经关注了公众号
      // 如果未关注，才显示二维码
     // this.showQrcode = true
     try {
        // 显示加载状态
        this.showLoading = true;
        // 调用API验证用户关注状态
        // 这里使用实际的API调用，而不是模拟
        const response = await prizeAPI.verifyFollowStatus(globalStore.getUrlParams());
        //console.log("验证关注状态响应:",response);
        // 根据验证结果处理
        if (response && response.code==0 && response.data.isFollowed) {
          // 用户已关注，关闭弹窗并跳转到答题页面
          this.showQrcode = false;
          // 跳转到答题页面，传递全局URL参数
          this.$router.push({
            path: '/records',
            query: this.getGlobalParams() // 传递全局URL参数
          });
        } else {
          // 用户未关注，显示提示
        //  alert('请先关注公众号后再继续');
          // 保持弹窗开启，让用户继续关注
           this.showQrcode = true
        }
      } catch (error) {
        console.error('验证关注状态失败:', error);
        alert('网络错误，请稍后重试');
      } finally {
        // 无论成功失败，都隐藏加载状态
        this.showLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.header {
  margin-bottom: 40px;
  padding-top: 40px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
}

.header-left {
  flex: 1;
  text-align: center;
}

.title {
  font-size: 2.5rem;
  color: white;
  margin-bottom: 15px;
  font-weight: 700;
  text-shadow: 0 4px 8px rgba(0,0,0,0.3);
  letter-spacing: -1px;
}

/* URL参数显示区域样式 */
.params-display {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  padding: 20px;
  margin: 0 auto 30px;
  max-width: 600px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.params-display h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.params-display ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.params-display li {
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  color: #666;
}

.params-display li:last-child {
  border-bottom: none;
}

/* 二维码弹窗样式 */
.qrcode-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 20px;
  padding: 30px;
  width: 90%;
  max-width: 350px;
  text-align: center;
  position: relative;
  animation: modalSlide 0.3s ease-out;
}



/* 活动状态弹窗样式 */
.act-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.act-content {
    background: white;
    border-radius: 24px;
    padding: 40px 30px;
    width: 90%;
    max-width: 380px;
    text-align: center;
    position: relative;
    animation: modalSlide 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.18);
  }
  
  /* 弹窗动画 */
  @keyframes modalSlide {
    from {
      opacity: 0;
      transform: translateY(20px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }


.status-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.status-title {
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 15px;
}

.act-tip {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 30px;
  padding: 0 10px;
}

.status-confirm-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px 40px;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  min-width: 150px;
}

.status-confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.status-confirm-btn:active {
  transform: translateY(0);
}

/* 响应式优化 */
@media (max-width: 480px) {
  .act-content {
    padding: 30px 20px;
    margin: 0 20px;
  }
  
  .status-icon {
    font-size: 3rem;
  }
  
  .status-title {
    font-size: 1.3rem;
  }
  
  .act-tip {
    font-size: 1rem;
  }
}
@keyframes modalSlide {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
  }  
  
  .close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #f5f5f5;
  transition: all 0.3s;
}

.close-btn:hover {
  background: #e0e0e0;
  color: #666;
}

.modal-content h3 {
  color: #333;
  margin-bottom: 20px;
  font-size: 1.5rem;
}

.qrcode-container {
  margin-bottom: 20px;
}

.qrcode-placeholder {
  margin-bottom: 15px;
}

.qrcode-tip {
  color: #666;
  font-size: 1rem;
  margin-top: 10px;
}
.act-tip {
  color: #666;
  font-size: 1rem;
  margin-top: 10px;
}
.follow-instruction {
  color: #666;
  margin-bottom: 20px;
  font-size: 0.9rem;
}

.confirm-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.subtitle {
  font-size: 1.2rem;
  color: rgba(255,255,255,0.9);
  font-weight: 300;
}

.record-btn {
  background: rgba(255,255,255,0.2);
  border: 2px solid rgba(255,255,255,0.3);
  color: white;
  padding: 10px 20px;
  margin-top: 20px;
  border-radius: 30px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.record-btn:hover {
  background: rgba(255,255,255,0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}

.content {
  max-width: 800px;
  margin: 0 auto;
}

.card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
  transform: translateY(0);
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.card-icon {
  width: 120px;
  height: 120px;
  margin: 0 auto 20px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.card-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transition: transform 0.3s ease;
}

.card:hover .card-icon {
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 15px 30px rgba(0,0,0,0.15);
}

.card:hover .card-icon img {
  transform: scale(1.1);
}

.card-title {
  font-size: 2rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.card-description {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
}

.start-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.start-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.start-btn:active {
  transform: scale(0.98);
}

.arrow-right {
  font-size: 0.9rem;
  transition: transform 0.3s ease;
}

.start-btn:hover .arrow-right {
  transform: translateX(5px);
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 60px;
}

.feature-item {
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(255,255,255,0.2);
}

.feature-item:hover {
  background: rgba(255,255,255,0.2);
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: white;
}

.feature-title {
  font-size: 1.2rem;
  color: white;
  margin-bottom: 10px;
  font-weight: 600;
}

.feature-desc {
  font-size: 1rem;
  color: rgba(255,255,255,0.8);
}

.footer {
  text-align: center;
  padding: 20px 0;
  color: rgba(255,255,255,0.6);
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }
  
  .card {
    padding: 30px 20px;
  }
  
  .card-title {
    font-size: 1.8rem;
  }
  
  .features {
    grid-template-columns: 1fr;
  }
}
</style>